import styled from "styled-components";
import { TextField as TextFieldMaterialUI } from "@mui/material";

export const TextField = styled(TextFieldMaterialUI)`
  flex: 1 1 calc((100% - 260px) / 4);
  min-width: 260px;
`;

export const Label = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: rgba(15, 15, 30, 0.6);
`;

export const LableTitle = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: rgba(15, 15, 30, 0.6);
`;

export const Span = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: rgba(15, 15, 30, 0.6);
`;
